import React from 'react';
import CopyToClipboard from '../copy-to-clipboard/CopyToClipboard';
import { Flex } from 'antd';

const TextWithCopy = ({
  value = '',
  containerClassName = '',
  textClassName = '',
  textStyle = {},
  gap = 5,
  valueToCopy = '',
  renderExtraIcon = () => {},
}) => {
  const copyValue = valueToCopy ? valueToCopy : value;
  return (
    <Flex align="center" className={containerClassName} gap={gap}>
      <div className={textClassName} style={textStyle}>
        <CopyToClipboard value={value} allowCopy={copyValue} />
      </div>
      {renderExtraIcon()}
    </Flex>
  );
};

export default TextWithCopy;
